import React, { forwardRef, useMemo } from "react";
import classNames from "classnames";
var Hidden = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.as, Component = _b === void 0 ? "div" : _b, type = _a.type, breakpoint = _a.breakpoint, className = _a.className, style = _a.style;
    var combinedClassName = useMemo(function () {
        var baseClass = "fr-".concat(type);
        var breakpointClass = breakpoint ? "-".concat(breakpoint) : "";
        if (type === "unhidden") {
            return classNames("fr-hidden", baseClass + breakpointClass, className);
        }
        else if (type === "sr-only" || type === "hidden") {
            return classNames(baseClass + breakpointClass, className);
        }
        return classNames(className);
    }, [type, breakpoint, className]);
    if (!children)
        throw new Error("Children are required for Hidden component");
    return (React.createElement(Component, { className: combinedClassName, ref: ref, style: style }, children));
});
export default Hidden;
